import { useEffect, useState } from 'react'

import noConnection from '../../../assets/icons/noConnection.png'
import { fontSizes, fontWeights } from '../../../constants/salesStyles'

import styles from './styles.module.scss'

const TechnicalInfoBanner = () => {
    const [isClosed, setIsClosed] = useState(false)

    useEffect(() => {
        const closedStatus = localStorage.getItem('technicalInfobanner_max_add_contact')
        if (closedStatus === 'true') {
            setIsClosed(true)
        }
    }, [])

    const handleClose = () => {
        localStorage.setItem('technicalInfobanner_max_add_contact', 'true')
        setIsClosed(true)
    }

    if (isClosed) return null

    return (
        <div className={styles.wrap}>
            <img src={noConnection} alt="noConnection" className={styles.icon} />
            <div className={styles.content}>
                <button className={styles.closeButton} onClick={handleClose} aria-label="Close banner">
                    ×
                </button>
                <p style={{ fontSize: fontSizes.xs, fontWeight: fontWeights.normal }}>
                    Поддержка в МАКС временно недоступна. По всем вопросам пишите в Telegram:{' '}
                    {/* Временно скрыто: поддержка в МАКС
                        <a href="https://max.ru/u/f9LHodD0cOIAVt7Zg_ukFhe6Qw_5sgNWro0T4-_WyxIKxbVugh-hydSRlno" target="_blank" rel="noopener noreferrer">
                            +79365150373
                        </a>{' '}
                        в контакты телефона. Тогда сообщения будут приходить. Без этого МАКС может блокировать сообщения.
                    */}
                    <a href="https://t.me/partsautoexpert_bot" target="_blank" rel="noopener noreferrer">
                        @partsautoexpert_bot
                    </a>{' '}
                </p>
            </div>
        </div>
    )
}

export default TechnicalInfoBanner
